import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="create-invoices"
export default class extends Controller {
  connect() {
    console.log("CreateInvoices controller connected");
  }

  createInvoices(event) {
    event.preventDefault();
    if (!confirm("本当に請求書を作成して当該受付を締めますか？")) return;

    const checkedElements = document.querySelectorAll(
      "[name^='client_ids']:checked"
    );
    const sale_ids = Array.from(checkedElements)
      .map((checkbox) => {
        const data = checkbox.closest("tr").dataset.clientSalesIds;
        return JSON.parse(data);
      })
      .flat();

    const form = document.createElement("form");
    form.method = "POST";
    form.action = "/sales/create_invoices";
    form.target = "_blank";

    const csrfToken = document.querySelector('meta[name="csrf-token"]').content;
    const csrfInput = document.createElement("input");
    csrfInput.type = "hidden";
    csrfInput.name = "authenticity_token";
    csrfInput.value = csrfToken;
    form.appendChild(csrfInput);

    sale_ids.forEach((id) => {
      const input = document.createElement("input");
      input.type = "hidden";
      input.name = "sale_ids[]";
      input.value = id;
      form.appendChild(input);
    });

    const start_at = document.createElement("input");
    start_at.type = "hidden";
    start_at.name = "start_at";
    start_at.value = document.getElementById("q_delivered_at_gteq").value;
    form.appendChild(start_at);

    const end_at = document.createElement("input");
    end_at.type = "hidden";
    end_at.name = "end_at";
    end_at.value = document.getElementById("q_delivered_at_lteq").value;
    form.appendChild(end_at);

    const charged_at = document.createElement("input");
    charged_at.type = "hidden";
    charged_at.name = "charged_at";
    charged_at.value = document.getElementById("charged_at").value;
    form.appendChild(charged_at);

    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
  }
}
